import * as yup from 'yup';

export const PasswordAndPinSchema = yup.object({
  password: yup.string().required().min(8),
  previousPassword: yup.string().required(),
  pin: yup.string().required().min(6).matches(/^\d+$/),
});

export interface IPasswordAndPin {
  password: string;
  previousPassword: string;
  pin: string;
}
